// extracted by mini-css-extract-plugin
module.exports = {"container":"skills_report-module_container_9bfcf","item":"skills_report-module_item_81011"};